import { useEffect, useState } from 'react';

/**
 * Hook to calculate actual viewport height for iOS Safari compatibility.
 * iOS Safari's 100vh doesn't account for browser chrome, so we use window.innerHeight instead.
 *
 * @returns {string} The viewport height as a CSS value (e.g., "812px")
 */
export const useViewportHeight = () => {
  const [viewportHeight, setViewportHeight] = useState('100vh');

  useEffect(() => {
    const updateViewportHeight = () => {
      const vh = window.innerHeight;
      setViewportHeight(`${vh}px`);
    };

    // Set initial height
    updateViewportHeight();

    // Update on resize/orientation change
    window.addEventListener('resize', updateViewportHeight);
    window.addEventListener('orientationchange', updateViewportHeight);

    return () => {
      window.removeEventListener('resize', updateViewportHeight);
      window.removeEventListener('orientationchange', updateViewportHeight);
    };
  }, []);

  return viewportHeight;
};
